import React, { useState, useEffect } from 'react';

function Notification({ type, message, alertMsg }) {
  useEffect(() => {
    setTimeout(() => {
      alertMsg(false);
    }, 3000);
  });

  return (
    <div>
      {type === 'success' && (
        <div
          className="px-4 py-2 absolute z-50 bottom-6 left-6 items-center text-white leading-none lg:rounded-full flex lg:inline-flex"
          style={{ zIndex: '999999', background: '#66ff99' }}
          role="alert"
        >
          {/* <span className="flex rounded-full bg-green-700 uppercase px-2 py-1 text-xs font-bold mr-3">New</span> */}
          <span className="font-semibold mr-3 text-left flex-auto">{message}</span>
        </div>
      )}
      {type === 'error' && (
        <div
          className="px-4 py-2 absolute z-50 bottom-6 left-6 items-center bg-red-800 text-white leading-none lg:rounded-full flex lg:inline-flex"
          style={{ zIndex: '999999' }}
          role="alert"
        >
          {/* <span className="flex rounded-full bg-red-500 uppercase px-2 py-1 text-xs font-bold mr-3">New</span> */}
          <span className="font-semibold mr-3 text-left flex-auto">{message}</span>
        </div>
      )}
      {type === 'update' && (
        <div
          className="px-4 py-2 absolute z-50 bottom-6 left-6 items-center bg-blue-800 text-white leading-none lg:rounded-full flex lg:inline-flex"
          style={{ zIndex: '999999' }}
          role="alert"
        >
          {/* <span className="flex rounded-full bg-blue-500 uppercase px-2 py-1 text-xs font-bold mr-3">New</span> */}
          <span className="font-semibold mr-3 text-left flex-auto">{message}</span>
        </div>
      )}
      {type === 'delete' && (
        <div
          className="px-4 py-2 absolute z-50 bottom-6 left-6 items-center bg-red-100 items-center text-red-700 leading-none lg:rounded-md flex lg:inline-flex"
          style={{ zIndex: '999999' }}
          role="alert"
        >
          {/* <span className="flex rounded-full bg-red-100 uppercase px-2 py-1 text-xs font-bold mr-3">New</span> */}
          <span className="font-semibold mr-3 text-left flex-auto">{message}</span>
        </div>
      )}
    </div>
  );
}
export default Notification;
